export const translation_11_3_A = {
  en: {},
  ko: {
    v1: {
      typography_0: `꾸러미와 상황`,
      typography_1: `지난 시간에 생각과 감정, 신체 반응, 행동 충동이 하나의 '꾸러미'처럼 얽혀서 나타난다고 배웠습니다. 꾸러미를 각각의 요소로 해체하기 전에 먼저 해야할 일이 있습니다. 바로 가장 먼저 방아쇠 역할을 한 '상황'을 찾아내는 것입니다.`,
      typography_2: `경험 꾸러미를 촉발시킨 '상황'을 찾아낼 때에는 일상에서 마주하는 수많은 자극 중, 마음을 요동치게 한 정확한 지점을 찾는 것이 중요합니다. 마치 엉킨 실타래에서 첫 시작점을 찾아내는 것처럼 말이죠.`,

      typography_3: `객관적인 사실`,
      typography_4: `상황을 기록할 때 가장 중요한 첫 번째 원칙은 주관을 제하고 객관적인 사실만 적는 것입니다. 마치 CCTV나 녹음기에 담긴 파일처럼 있는 그대로의 사실로만 정리해야 합니다. 개인적인 짐작이나 평가가 들어가는 순간, 그것은 더 이상 상황이 아니라 '생각'이 되어버리기 때문입니다.`,
      typography_5: `예를 들어 "친구가 나를 무시하며 지나감"에는 주관적인 평가가 들어 있습니다. 주관적 평가를 제하고 "친구가 내 인사에 대답하지 않고 지나감"이라고 적어야 합니다. 이처럼 감정과 판단의 안경을 벗고 상황을 있는 그대로 바라보는 연습이 필요합니다.`,
      typography_6: `다음 중 '상황'을 객관적인 사실로만 바르게 기록한 문장은 무엇일까요?`,
      typography_quiz_incorrect: `활동지를 천천히 살펴본 뒤 다시 답해보세요.`,
      typography_7: `정답은 C입니다. A와 B에는 '귀찮아하며', '고의로 무시함'과 같은 주관적인 짐작과 평가가 포함되어 있습니다. 반면 C는 CCTV로 찍은 것처럼 있는 그대로의 사실만을 적었으므로 올바른 상황 기록입니다.`,
      typography_8: `그렇다면 "팀장님이 나를 귀찮아하며 회의를 서둘러 끝냄"을 올바른 '상황'으로 가장 잘 고친 것은 무엇일까요?`,
      typography_9: `정답은 B입니다. '싫어해서'나 '피곤한 기색으로' 역시 개인적인 해석입니다. '시계를 본 뒤'와 '회의를 마침'는 누구나 동의할 수 있는 객관적인 사실입니다.`,

      typography_10: `순간의 포착`,
      typography_11: `두 번째 원칙은 상황을 긴 '선'이 아니라 짧은 '점'처럼 포착하는 것입니다. 많은 분들이 이 연습을 처음 시작하면, "요즘 회사 일이 많다"거나 "어릴 적부터 가족들과 사이가 안 좋았다"라며 여러 사건을 뭉뚱그려 표현하곤 합니다. 하지만 상황을 찾아낼 때에는, 내게 부정적 반응을 가장 강하게 일으킨 특정 순간 하나를 콕 짚어내야 합니다.`,
      typography_12: `예를 들어, "요즘 회사 일이 많다"라는 선 속에는 다음과 같은 많은 점들이 존재합니다.`,
      typography_situation_1: `팀장님이 내게 자료 정리를 요청함`,
      typography_situation_2: `야근하다가 11시가 되었음`,
      typography_situation_3: `주말에 회사 메신저가 울림`,
      typography_13: `이 각각의 사건들은 각각 별개의 꾸러미를 만들어냈을 것입니다. 우리가 기록하며 '경험 분리'를 연습할 때에는 이 중 나를 가장 크게 흔든 단 하나의 순간을 먼저 선택해야 합니다.`,
      typography_14: `다음 중 상황을 '선'이 아닌 '점'으로 잘 포착한 기록은 무엇일까요?`,
      typography_15: `정답은 B입니다. A와 C는 특정 기간 동안 일어난 여러 사건을 하나로 뭉뚱그린 '선'에 해당합니다. 반면 B는 부정적인 반응이 촉발된 정확한 찰나의 순간을 '점'으로 포착했습니다.`,
      typography_16: `그렇다면 "이번 주 내내 업무가 너무 많아서 야근을 함"을 알맞은 '상황'으로 고친 문장은 무엇일까요?`,
      typography_17: `정답은 A입니다. B에는 주관적인 감정이 포함되어있으며, C는 여전히 특정 순간보다는 근래의 상태를 표현하고 있습니다. A처럼 좌절감이나 스트레스라는 꾸러미를 안겨준 '그 순간의 사건'을 포착하는 것이 중요합니다.`,

      typography_18: `현재에 초점`,
      typography_19: `세 번째 원칙은 시선을 과거가 아닌 '현재'에 맞추는 것입니다. 디스턴싱 기술을 이제 막 익히기 시작한 지금 단계에서는 오래전의 이야기를 해집어 내지는 않을 겁니다. 그보다는 지금 이 순간 일어나는 일들에 먼저 집중하여, 실질적으로 체감할 수 있는 변화를 만들어낼 것입니다. 따라서 몇 달이나 몇 년 전의 과거보다는 최근에 일상적에 겪는 어려움을 다루는 것이 좋습니다.`,
      typography_20: `만약 과거의 기억이 현재의 나를 괴롭힌다면, 과거의 그 사건이 벌어진 때가 아니라, 그 과거가 '현재'에 영향을 미친 순간을 상황으로 삼아야 합니다.`,
      typography_21: `예를 들어 "3개월 전 키우던 반려견이 세상을 떠남"이라고 적는 대신, "오늘 TV에서 동물 프로그램을 보다가 반려견이 생각남"이라고 적는 식입니다. 이렇게 하면 통제할 수 없는 과거 대신, 지금 당장 다룰 수 있는 현재의 경험으로 초점을 옮겨올 수 있습니다.`,
      typography_22: `5년 전 친구와 크게 싸우고 절교한 일이 여전히 나를 괴롭힙니다. 이를 '현재에 초점을 맞춘 상황'으로 가장 잘 기록한 것은 무엇일까요?`,
      typography_23: `정답은 B입니다. A는 과거의 사건 자체이며, C는 내면의 생각과 감정입니다. B는 과거의 상처가 '지금 이 순간' 어떻게 트리거가 되었는지를 보여주는 훌륭한 상황 기록입니다.`,

      typography_24: `내면의 상황`,
      typography_25: `많은 분들이 "나는 특별한 트리거가 없이 꾸러미를 경험하는데 어떡하냐"라고 하기도 하는데요. 하지만 트리거 없이 꾸러미를 경험할 수는 없습니다.`,
      typography_26: `경험 꾸러미를 촉발시킨 트리거는 언제나 존재합니다. 우리가 자동 조종 상태에 있어서 그것을 알아차리지 못했을 뿐입니다. '신성한 멈춤'을 하지 못했다는 뜻이지요. 그렇기에 우린 지금 그 트리거가 되는 상황을 잘 찾아낼 수 있도록 연습하고 있는 것입니다.`,
      typography_27: `하지만 알아차리려 노력해도 트리거를 찾지 못한 경우, 너무 애쓰지 않아도 좋습니다. 그럴 때에는 그 당시에 무엇을 보고, 듣고 있었는지 등을 포함하여 '내적 상황'의 형태로라도 정리하는 것이 좋습니다.`,
      typography_28: `예를 들어, "퇴근길에 문득"이나 "잠자리에 누웠을 때 문득"과 같이 내적 상황의 형태로라도 우선 연습하는 것이 좋습니다. 연습을 반복하다보면, 그 '문득'의 찰나에 어떤 트리거가 있었는지 알아차리는 순간들이 많아질 것입니다.`,

      typography_29: `직접 해보기`,
      typography_30: `지금까지 꾸러미를 촉발한 상황을 찾아내는 과정에서 주의해야 할 중요한 원칙들을 살펴보았습니다. 다음의 세 가지를 꼭 기억해주세요. 이 원칙들은 앞으로 꾸준히 훈련할 '거리두기' 기술의 튼튼한 기초가 될 것입니다.`,
      typography_principle_1: `객관적인 사실로 적기`,
      typography_principle_2: `선이 아닌 점으로 포착하기`,
      typography_principle_3: `현재에 초점을 맞추기`,
      typography_31: `이제 이 원칙들을 일상에 직접 적용해 볼 차례입니다. 최근 강렬한 생각과 감정의 꾸러미가 촉발된 시작점을 찬찬히 떠올려 보세요. 방금 살펴본 원칙을 바탕으로, 마음을 요동치게 했던 바로 그 '상황'을 객관적인 한 문장으로 기록해 보는 겁니다.`,
      typography_32: `최근 겪은 부정적인 경험을 떠올려 보고, 그것을 촉발한 '상황'을 적어보세요.`,
      typography_33: `좋습니다. 코치 선생님이 확인 후 피드백 남겨주실 겁니다.`,
    },
  },
};
